"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapApiToPhoto = exports.mapApiToFile = void 0;
const mapApiToFile = ({ nazev, attach_id, ulozeni }, type, getUrl = undefined) => {
    return {
        nazev,
        url: getUrl ? getUrl(attach_id) : undefined,
        attach_id,
        type,
        path: ulozeni
    };
};
exports.mapApiToFile = mapApiToFile;
const mapApiToPhoto = (apiItem) => {
    return (0, exports.mapApiToFile)(apiItem, "image", item => apiItem.ulozeni ?? "");
};
exports.mapApiToPhoto = mapApiToPhoto;
